<template>
  <el-drawer
  :title="$t('common.options')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    
    <h5>{{ $t('inventories.productTable') }}</h5>
    <el-select
      v-model="model.columns"
      multiple
      @change="handleColumnsChange"
      collapse-tags
      value-key='code'>
      <el-option
        v-for="item in columnsOptions"
        :key="item.code"
        :label="$t('products.list.columns.' + item.code)"
        :value="item">
      </el-option>
    </el-select>
    <el-divider/>
  </div>
  <WatingDialog :visible="globalInventoryReportLoading"></WatingDialog>
</el-drawer>
</template>
<script>
import systemAPI from '@/services/API/system'
import cmsAPI from '@/services/API/cmsAPI'
import WatingDialog from '@/components/waiting-dialog'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'inventory-options-drawer',
	props: {
    inventoryId : {type : Number},
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      reportFilters : {
        puidPublished: false,
        puidUnpublished: false,
        showQuantity: false,
        withoutPrices: false,
        showUvc : true,
        showVolume: true,
        showVintage: true,
        taxesIn: false,
        taxesOut: true,
        type: 'PRODUCT_LISTING',
        countries: [],
        productTypes: [],
        available: true,
        upcoming: true,
      },
      reports : [
        { code: 'PRODUCT_LISTING', label: "Liste des produits formatté" }, 
        { code: 'INVENTORIES', label: "Liste des produits CSV"}
      ],
      countries: [],
      countriesLoading: false,
      productTypesLoading: false,
      productTypes: [],
      model : {
        columns : [],
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {
    WatingDialog,
  },
  watch : {

  },
	methods: {
    handleDownloadReport(){
      if (this.reportFilters.type == null) {

      } else {

        let webPublished = undefined;
        if (this.reportFilters.puidPublished === true && this.reportFilters.puidUnpublished === false) {
          webPublished= true;
        } else if (this.reportFilters.puidPublished === false && this.reportFilters.puidUnpublished === true) {
          webPublished= false;
        }

        let show = null;
        if (this.reportFilters.available === true && this.reportFilters.upcoming === false){
          show = "AVAILABLE"
        } else if (this.reportFilters.available === false && this.reportFilters.upcoming === true){
          show = "UPCOMING"
        } else if (this.reportFilters.available === true && this.reportFilters.upcoming === true){
          show = "AVAILABLE_UPCOMING"
        }

        let taxes = null;

        if (this.reportFilters.taxesIn === true && this.reportFilters.taxesOut === false) {
          taxes = 'IN';
        } else if (this.reportFilters.taxesIn === false && this.reportFilters.taxesOut === true) {
          taxes = 'OUT';
        } else if (this.reportFilters.taxesIn === true && this.reportFilters.taxesOut === true) {
          taxes = 'IN_OUT';
        }

        let showPrices = this.reportFilters.withoutPrices === true ? false : true;
        
        const params = {
          webPublished,
          showUvc: this.reportFilters.showUvc,
          showVintage: this.reportFilters.showVintage,
          showVolume: this.reportFilters.showVolume,
          showQuantity: this.reportFilters.showQuantity,
          showPrices,
          type: this.reportFilters.type,
          inventoryId: this.inventoryId,
          show,
          taxes,
          countries: this.reportFilters.countries,
          productTypes: this.reportFilters.productTypes,
          format: this.reportFilters.type === 'INVENTORIES' ? 'CSV' : 'PDF',
        };
        this.downloadInventoryReport(params);
      }
    },
    fetchProductTypes (){
      this.productTypesLoading = true;
      return cmsAPI.fetchProductTypes()
        .then(specificTypes=>{
          this.productTypes = specificTypes;
          this.productTypesLoading = false;

        })
    },
    fetchCountries () {
      this.countriesLoading = true;
      return systemAPI.fetchCountriesV2('products')
        .then((countries) => {
          this.countriesLoading = false;
          this.countries = countries;
        }).catch((err) => {
          this.countriesLoading = false;
          console.log(err);
        })
    },
    open(){
      this.fetchCountries();
      this.fetchProductTypes();
      this.model.columns = this.columns;
    },
    handleColumnsChange () {
      this.setColumns(this.model.columns);
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('inventoryProducts', ['downloadInventoryReport', 'setColumns'])
	},
	computed: {
    lang(){
      return this.$i18n.locale
    },
    productName(){
      if(this.selectedProduct==null) return "";
      else return this.selectedProduct.name;
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "30%";
      }else{
        return "100%"
      }
    },
    ...mapState('inventoryProducts', ['columnsOptions', 'columns', 'globalInventoryReportLoading']),
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
